<script>
import {defineComponent, ref} from "vue";
import {usePopupsControlStore} from "@js/store/PopupsControlStore.js";

export default defineComponent({
    name: "ErrorPopup",
    setup() {
        const popupsControlStore = usePopupsControlStore()
        const modalErrorPopupRef = ref(null)

        const closeModal = () => {
            popupsControlStore.isErrorPopupVisible = false
        }

        const handleBackgroundClick = (event) => {
            if (!modalErrorPopupRef.value.contains(event.target)) {
                closeModal()
            }
        }

        return {
            popupsControlStore,
            closeModal,
            modalErrorPopupRef,
            handleBackgroundClick
        }
    },
});
</script>

<template>
    <div v-if="popupsControlStore.isErrorPopupVisible"
         class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70 transition-opacity"
         @click="handleBackgroundClick">
        <div ref="modalErrorPopupRef"
             class="relative bg-gray-800 text-white rounded-2xl shadow-lg w-[90%] md:w-auto p-6 md:p-10 intro-y">
            <button @click="closeModal"
                    class="absolute top-2 right-2 text-gray-400 hover:text-white focus:outline-none">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6"
                     fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
                </svg>
            </button>
            <div class="text-center">
                <div class="flex items-center justify-center w-12 h-12 mx-auto mb-4 bg-red-500 rounded-full">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" version="1.1" id="_x32_"
                         viewBox="0 0 512 512" xml:space="preserve">
                        <path class="st0" fill="#fff"
                              d="M238.301 346.393c.598 3.938 2.563 7.725 5.903 11.359 3.313 3.626 7.252 5.447 11.796 5.447 10.592 0 16.486-5.608 17.691-16.806l35.398-271.98c.607-4.823.911-11.636.911-20.415 0-13.618-4.679-26.013-14.065-37.22C286.558 5.59 273.244 0 255.999 0c-17.868 0-31.317 5.742-40.389 17.226C206.537 28.432 202 40.685 202 53.999c0 8.172.285 14.976.892 20.415l35.409 271.979zM295.033 418.065c-10.288-10.287-23.307-15.44-39.034-15.44-15.422 0-28.441 5.314-39.032 15.896-10.591 10.591-15.877 23.441-15.877 38.569 0 14.52 5.286 27.379 15.877 38.577C227.558 506.562 240.578 512 255.999 512c15.423 0 28.424-5.286 39.034-15.886 10.574-10.574 15.877-23.593 15.877-39.024 0-15.432-5.303-28.434-15.877-39.025z"/>
                    </svg>
                </div>
                <h2 class="text-2xl font-bold">
                    Что то пошло не так...
                </h2>
                <p class="mt-2 text-md text-gray-300">
                    Попробуйте еще раз чуть позже.
                </p>
            </div>
        </div>
    </div>
</template>

<style scoped>
</style>
